
export enum AttendanceStatus {
  PRESENT = 'Trabajando',
  ABSENT = 'Descansando',
}

export enum AttendanceMethod {
  PHOTO = 'Photo',
  CODE = 'Code',
  NONE = 'None',
}

export enum AreaStatus {
  ACTIVO = 'Activo',
  INACTIVO = 'Inactivo',
}

export interface Area {
  id: number;
  name: string;
  status: AreaStatus;
}

export interface Employee {
  Id: number;
  Name: string;
  AreaName: string;
  IdArea: number;
  Enabled: number;
  Status: number; 
  IdAttendance:number; 
  Avatar:string;
}

